// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./text/MaerskText-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./text/MaerskText-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./text/MaerskText-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./text/MaerskText-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./text/MaerskText-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./text/MaerskText-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./text/MaerskText-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./text/MaerskText-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./text/MaerskText-MediumItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./text/MaerskText-MediumItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./text/MaerskText-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./text/MaerskText-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./headline/MaerskHeadline-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./headline/MaerskHeadline-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./headline/MaerskHeadline-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./headline/MaerskHeadline-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./headline/MaerskHeadline-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./headline/MaerskHeadline-Light.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Maersk Text */
@font-face {
  font-family: "Maersk Text";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}
@font-face {
  font-family: "Maersk Text";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
}
@font-face {
  font-family: "Maersk Text";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
}
@font-face {
  font-family: "Maersk Text";
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
}
@font-face {
  font-family: "Maersk Text";
  font-style: italic;
  font-weight: 500;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff");
}
@font-face {
  font-family: "Maersk Text";
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff");
}
/* Maersk Headline */
@font-face {
  font-family: "Maersk Headline";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff");
}
@font-face {
  font-family: "Maersk Headline";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff");
}
@font-face {
  font-family: "Maersk Headline";
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff");
}
`, "",{"version":3,"sources":["webpack://./node_modules/@maersk-global/fonts/maeu/fonts.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;0DACsD;AACxD;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;0DACqD;AACvD;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;0DACmD;AACrD;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;0DACqD;AACvD;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;0DAC2D;AAC7D;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;2DACyD;AAC3D;AACA,oBAAoB;AACpB;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;2DAC8D;AAChE;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;2DAC2D;AAC7D;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;2DAC4D;AAC9D","sourcesContent":["/* Maersk Text */\n@font-face {\n  font-family: \"Maersk Text\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(\"./text/MaerskText-Regular.woff2\") format(\"woff2\"),\n    url(\"./text/MaerskText-Regular.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Maersk Text\";\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(\"./text/MaerskText-Medium.woff2\") format(\"woff2\"),\n    url(\"./text/MaerskText-Medium.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Maersk Text\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(\"./text/MaerskText-Bold.woff2\") format(\"woff2\"),\n    url(\"./text/MaerskText-Bold.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Maersk Text\";\n  font-style: italic;\n  font-weight: 400;\n  font-display: swap;\n  src: url(\"./text/MaerskText-Italic.woff2\") format(\"woff2\"),\n    url(\"./text/MaerskText-Italic.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Maersk Text\";\n  font-style: italic;\n  font-weight: 500;\n  font-display: swap;\n  src: url(\"./text/MaerskText-MediumItalic.woff2\") format(\"woff2\"),\n    url(\"./text/MaerskText-MediumItalic.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Maersk Text\";\n  font-style: italic;\n  font-weight: 700;\n  font-display: swap;\n  src: url(\"./text/MaerskText-BoldItalic.woff2\") format(\"woff2\"),\n    url(\"./text/MaerskText-BoldItalic.woff\") format(\"woff\");\n}\n/* Maersk Headline */\n@font-face {\n  font-family: \"Maersk Headline\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(\"./headline/MaerskHeadline-Regular.woff2\") format(\"woff2\"),\n    url(\"./headline/MaerskHeadline-Regular.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Maersk Headline\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(\"./headline/MaerskHeadline-Bold.woff2\") format(\"woff2\"),\n    url(\"./headline/MaerskHeadline-Bold.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Maersk Headline\";\n  font-style: normal;\n  font-weight: 300;\n  font-display: swap;\n  src: url(\"./headline/MaerskHeadline-Light.woff2\") format(\"woff2\"),\n    url(\"./headline/MaerskHeadline-Light.woff\") format(\"woff\");\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
